import { TableOutlined,HomeOutlined,TeamOutlined,ShoppingCartOutlined,AccountBookOutlined,FlagOutlined } from '@ant-design/icons';
import { SmileOutlined,RedEnvelopeOutlined,CrownOutlined,RiseOutlined,WechatOutlined,YoutubeOutlined} from '@ant-design/icons';
import { SettingOutlined,PropertySafetyOutlined,MessageOutlined,SafetyOutlined} from '@ant-design/icons';
const IconMap:Record<string, any> = {
    "数据中心"  :   <TableOutlined />,
    "首页管理"  :   <HomeOutlined />,
    "用户管理"  :   <TeamOutlined />,
    "商品管理"  :   <ShoppingCartOutlined />,
    "订单管理"  :   <AccountBookOutlined />,
    "营期管理"  :   <FlagOutlined />,
    "乐游卡管理":   <SmileOutlined />,
    "优惠券管理":   <RedEnvelopeOutlined />,
    "活动管理"  :   <CrownOutlined />,
    "成长值管理":   <RiseOutlined />,
    "微信视频号":   <WechatOutlined />,
    "直播管理"  :   <YoutubeOutlined />,
    "通用设置"  :   <SettingOutlined />,
    "财务管理"  :   <PropertySafetyOutlined />,
    "消息通知"  :   <MessageOutlined />,
    "权限管理"  :   <SafetyOutlined />,
}
export default IconMap;